import styled from 'styled-components'
import { Heading } from 'common-components'

const Score = styled.span`
  font-size: 3rem;
  line-height: 1rem;
`

const RiskScoreWrapper = styled.div`
  font-size: 0.9rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`

export const RiskScore = ({ score }) => (
  <RiskScoreWrapper>
    <p>คะแนนที่ท่านได้</p> <Score>{score}</Score> คะแนน
  </RiskScoreWrapper>
)

export const RiskScoreDesc = ({ riskLevelLabel, riskLevelDesc }) => (
  <div>
    <Heading>ท่านเป็น{riskLevelLabel}</Heading>
    <div>หมายความว่า ท่าน{riskLevelDesc}</div>
  </div>
)
